import { DropdownCloseButton } from './DropdownCloseButton'
import { DropdownFooter } from './DropdownFooter'
import { DropdownList } from './DropdownList'
import { DropdownListItem } from './DropdownListItem'
import { DropdownListItemButton } from './DropdownListItemButton'
import { DropdownRoot } from './DropdownRoot'

export const Dropdown = {
  Root: DropdownRoot,
  CloseButton: DropdownCloseButton,
  Footer: DropdownFooter,
  List: DropdownList,
  ListItem: DropdownListItem,
  ListItemButton: DropdownListItemButton,
}
